import Highcharts from 'highcharts';

import { CustomTheme } from '../../styles';


function enableChartsTheme(theme: CustomTheme) {
	Highcharts.setOptions({
		global: {
			useUTC: true,
		},
		credits: {
			enabled: false
		},
		lang: {
			decimalPoint: ',',
			thousandsSep: ' ',
			numericSymbols: [' тыс.' , ' млн.' , 'млрд.' , ' трлн.' , ' P' , ' E'],
			resetZoom: 'Установить исходный масштаб',
		},
		colors: [theme.palette.blackStealthy, '#fe6b74', '#4a90e2'],
		chart: {
			height: 400,
			backgroundColor: 'transparent',
			plotBackgroundColor: 'transparent',
			style: {
				fontFamily: 'Roboto',
			}
		},
		plotOptions: {
			spline: {
				marker: {
					fillColor: '#fff',
					lineColor: null,
					lineWidth: 1
				}
			},
			column: {
				animation: true,
				pointPadding: 0,
				borderWidth: 0
			},
			series: {
				animation: {
					duration: 800
				}
			}
		},
		legend: {
			align: 'center',
			verticalAlign: 'top',
			borderWidth: 0,
			borderRadius: 0,
			symbolHeight: 12,
			symbolWidth: 12,
			symbolRadius: 6,
			symbolPadding: 15,
			itemMarginTop: 0,
			itemStyle: {
				fontWeight: 'normal',
				fontSize: '12px',
			}
		},
		tooltip: {
			backgroundColor: '#3e4757',
			borderRadius: 0,
			borderWidth: 0,
			shadow: false,
			style: {
				color: '#fff',
				fontSize: '12px',
			},
			headerFormat: '',
			pointFormat: '{series.name}: {point.y}<br/>'
		},
		xAxis: {
			gridLineWidth: 1,
			gridLineColor: '#ebebeb',
			labels: {
				style: {
					fontSize: '10px',
				}
			}
		},
		yAxis: {
			gridLineWidth: 1,
			gridLineColor: '#ebebeb'
		}
	});
}

export default enableChartsTheme;